import React, { useState, Suspense } from 'react'
import faqArray from '../../../assets/dummy'
import QuestionDetail from '../../ContentWithIcon'

const questions = faqArray

const QASectionSub = ({ tags, textColor, bgColor }) => {
  const [selectedTag, setSelectedTag] = useState(tags[0].name)
  const [openQuestionIndex, setOpenQuestionIndex] = useState(null)
  const handleToggle = index => {
    setOpenQuestionIndex(prevIndex => (prevIndex === index ? null : index))
  }
  const filteredQuestions = questions.filter(
    q => q.category === tags.find(tag => tag.name === selectedTag)?.category
  )

  return (
    <section
      id='about'
      className={`h-[70vh] f-screen  ${
        bgColor ? `bg-${bgColor}` : 'bg-[#EBF4FF]'
      } shadow-[0px_0px_8px_0px_rgba(0,_0,_0,_0.12)] inset rounded-2xl mobile:h-[80vh]`}
    >
      <div className='container mx-auto py-10 px-5 mobile:py-5 mobile:px-3 tablet:py-5 tablet:px-4'>
        <div className='container-xs bottom-[0.06rem] items-center'>
          <div className='flex flex-row items-center justify-center mobile:text-[10px] '>
            <p
              className='uppercase text-center text-[36px] mobile:text-[16px] tablet:text-[32px] font-inter-bold'
              style={{ color: textColor || '#215998' }}
            >
              Түгээмэл асуулт хариултууд
            </p>
          </div>

          <div className='w-full flex flex-row mt-10 mobile:flex-col'>
            <div className='flex flex-col w-[160px] mobile:flex-row mobile:mb-4 mobile:gap-2 mobile:w-full tablet:w-[100px]'>
              {tags.map((item, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedTag(item.name)}
                  className={`w-full text-sm h-10 text-left border-t-0 border-r-0 border-b-0  mobile:border-b mobile:border-l-0
                    mobile:text-[11px]
                    font-${selectedTag === item.name ? 'bold' : 'normal'} 
                    border-b border-[#215998] 
                    ${selectedTag === item.name ? 'border-l' : ''} 
                    ${
                      selectedTag === item.name
                        ? 'text-[#215998]'
                        : 'text-[#626578]'
                    } 
                    cursor-pointer mobile:w-[20]`}
                >
                  <p className='ml-2'>
                  {item.category}
                  </p>
                </button>
              ))}
            </div>
            <div
              className='overflow-y-auto w-full h-[54vh] mt-[-10px] mobile:h-[60vh]  tablet:h-[60vh] faq-screen '
              style={{ scrollbarWidth: "thin",  scrollbarColor:" #215998 #90D5FF"}}
            >
              <Suspense fallback={<div>Loading feed...</div>}>
                {filteredQuestions.map((item, index) => (
                  <QuestionDetail
                    question={item.question}
                    answer={item.answer}
                    tags={tags}
                    key={'id' + index}
                    isOpen={openQuestionIndex === index}
                    onToggle={() => handleToggle(index)}
                  />
                ))}
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default QASectionSub
